<template>
	<div class="artist-detail">
		<h3 class="artist-detail-title">About the work</h3>

		<artwork-meta :metadata="artworkDetails"></artwork-meta>


		<template v-if="artwork.art_entry_type == 'digital'">
			<hr>
			<h4>Digital submission</h4>
			<artwork-meta :metadata="digitalDetails"></artwork-meta>
		</template>

		<template v-else>
			<hr>
			<h4>All other media</h4>
			<artwork-meta :metadata="physicalDetails"></artwork-meta>
		</template>

	</div>
</template>
<script>

import ArtworkMeta from './ArtworkMeta.vue';

export default {
	components: {
		ArtworkMeta
	},

	props: {
		artwork: {
			type: Object,
			required: true
		}
	},

	computed: {
		artworkDetails() {
			return [
				{
					label: 'ID',
					value: this.artwork.id,
					type: 'text'
				},
				{
					label: 'Title',
					value: this.artwork.title,
					type: 'text'
				},
				{
					label: 'Submission Date',
					value: this.artwork.date_full,
					type: 'text'
				},
				{
					label: 'Price',
					value: this.artwork.art_price,
					type: 'money'
				}
			];
		},

		digitalDetails() {
			return [
				{
					label: 'Duration',
					value: this.artwork.art_digital_duration,
					type: 'text'
				},
				{
					label: 'External Link',
					value: this.artwork.art_digital_url,
					link_text: 'View Artwork',
					type: 'link'
				},
				{
					label: 'Instructions',
					value: this.artwork.art_digital_url_details,
					type: 'text'
				}
			];
		},

		physicalDetails() {
			return [
				{
					label: 'Medium',
					value: this.artwork.art_medium,
					type: 'text'
				},
				{
					label: 'Instructions',
					value: this.artwork.art_physical_url_details,
					type: 'text'
				},
				{
					label: 'Height',
					value: this.artwork.art_dimensions_h,
					type: 'dimension'
				},
				{
					label: 'Width',
					value: this.artwork.art_dimensions_w,
					type: 'dimension'
				},
				{
					label: 'Depth',
					value: this.artwork.art_dimensions_depth,
					type: 'dimension'
				},
				{
					label: 'Weight',
					value: this.artwork.art_weight,
					type: 'weight'
				}
			];
		}
	}
}
</script>